import React, { useContext, useEffect, useRef, useState } from "react";
import { Modal } from "bootstrap";
import { GlobalContext } from "../../../../Context/GlobalContext";
import * as XLSX from "xlsx";
import { useGlobalFunction } from "../../../../Context/GlobalFunctionContext";
import { useNoteAlert } from "../../../../Context/pleaseNote";

export const AddItemByExcelUpload = ({ show, setShow, listId, updateList }) => {
  const { wishListAll, setWishListAll } = useContext(GlobalContext);
  const modalRef = useRef(null);
  const modalInstance = useRef(null);
  const fileInputRef = useRef(null);
  const requiredColumns = ["code"];
  const [fileError, setFileError] = useState(null);
  const [jsonData, setJsonData] = useState([]);
  const [fileDetails, setFileDetails] = useState(null);
  const { addExcelToWishList } = useGlobalFunction();
  const { showNoteAlert } = useNoteAlert();

  useEffect(() => {
    if (modalRef.current) {
      modalInstance.current = new Modal(modalRef.current, {
        backdrop: "static",
        keyboard: false,
      });
      if (show) handleShow();
      else handleHide();
    }
  }, [show]);
  const handleShow = () => {
    modalInstance.current?.show();
  };

  const handleHide = () => {
    setShow(false);
    modalInstance.current?.hide();
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const worksheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[worksheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

        if (jsonData.length > 0) {
          const headers = jsonData[0];
          const normalizedHeaders = headers.map((h) => h?.toString().trim().toLowerCase());
          //const isValid = requiredColumns.every((col) => headers.includes(col));
          const isValid = requiredColumns.every((col) => normalizedHeaders.includes(col));
          if (!isValid) {
            setFileError("The file must contain column header 'Code' .");
            setJsonData(null);
            showNoteAlert("The file must contain column header 'Code' .");
            handleHide();
            return;
          }
          const tableBody = jsonData.slice(1);
          if (tableBody) {
            const dataRows = tableBody.map((row) =>
              headers.reduce((acc, header, index) => {
                acc[header] = row[index];
                return acc;
              }, {}),
            );
            setJsonData(dataRows);
            setFileDetails({
              name: file.name,
              type: file.type,
              size: (file.size / 1024).toFixed(2),
            });
          } else {
            setFileError("The file doesn't have any records.");
            setJsonData(null);
            showNoteAlert("The file doesn't have any records.");
            handleHide();
            return;
          }
        }
      };

      reader.readAsArrayBuffer(file);
    }
  };

  const handleAddItemList = async () => {
    //const codes = jsonData.map((item) => item.Code);
    const codes = jsonData.map((item) => {
      const key = Object.keys(item).find((k) => k.toLowerCase() == "code");
      return key ? item[key] : null;
    });
    var response = await addExcelToWishList({
      listId: listId,
      productId: codes.join(","),
    });
    if (response) {
      fileInputRef.current.value = "";
      updateList();
      handleHide();
    }
  };

  return (
    <>
      <div
        className="modal fade"
        id="addFavModal"
        tabIndex={-1}
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
        ref={modalRef}
      >
        <div className="modal-dialog modal-dialog-centered modal-animate-center product-notfound-dialog">
          <div className="modal-content">
            <p className="order-status-close" data-bs-dismiss="modal" onClick={handleHide}>
              <i className="fa-regular fa-circle-xmark" />
            </p>
            <div className="modal-body p-0">
              <div className="product-found">
                <div className="product-found-title">
                  <span className="wes-excel-upload1" />
                  <h4>Add Item by Excel Upload</h4>
                </div>
                <div className="product-found-body">
                  <div className="fav-excel-upload">
                    <h5>Import Via Excel</h5>
                    <p className="fw-normal m-0 w-100 col-fs-13">
                      Import a Excel that contains the list of Products. This Excel should have one column: Code. For
                      more information{" "}
                      <a
                        href="https://cdn.wes.com.au/wesreact/src/ProductSample.xls"
                        target="_blank"
                        download="Sample-File.xlsx"
                        className="text-decoration-underline"
                      >
                        {" "}
                        click here{" "}
                      </a>
                      to download the sample format.{" "}
                    </p>
                    <div className="excelfile-Upload mt-3 text-center">
                      <i className="fa-solid fa-cloud-arrow-up" />
                      <input
                        type="file"
                        onChange={handleFileUpload}
                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                        id="excelupload"
                        ref={fileInputRef}
                      />
                      <p className="fs-15 fw-normal w-100 text-center mt-2 text-decoration-none fileChoose">
                        Drag File or <span style={{ color: "blue", fontWeight: "bold" }}>Choose</span> File to Upload
                      </p>
                    </div>
                  </div>
                  {fileDetails && (
                    <div className="uploaded-fav-excel d-flex align-items-start justify-content-between mt-4">
                      <div className="ct-fav-uploadedfile d-flex align-items-start justify-content-between">
                        <img
                          src="https://cdn.wes.com.au/wesreact/newui/img/my-account/excel-file.svg"
                          alt="Excel File"
                        />
                        <div className="fav-uploadedfile">
                          <h6>{fileDetails.name} </h6>
                          <span className="d-block fw-light fs-13 bg-grey">{fileDetails.size}KB</span>
                        </div>
                      </div>
                      <div className="ct-close">
                        <button type="submit" className="btn-close" onClick={() => setFileDetails(null)} />
                      </div>
                    </div>
                  )}
                  <div className="popupBtns mt-4">
                    <div className="button-effect">
                      <button type="submit" className="btn btn-products theme-primary" onClick={handleAddItemList}>
                        {" "}
                        Import Item
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
